var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-thumbnail",class:[
    { 'gallery-thumbnail--empty': !_vm.image },
    { 'gallery-thumbnail--clickable': _vm.clickable },
    { 'gallery-thumbnail--round': _vm.circle } ],style:({ backgroundImage: ("url(" + _vm.image + ")") }),on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }